import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapAcceptableUseToSections } from 'utils/legal/sections';

const AcceptableUse = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapAcceptableUseToSections(t), [language]);
  const title = t('title', 'acceptableuse') || 'Acceptable Use Policy';
  const lastUpdated = t('lastUpdated', 'acceptableuse') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default AcceptableUse;
